import { Diamond } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/property";

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="Property highlights"
      className="overflow-hidden border-y border-zinc-200 bg-[#F4F4F3] py-5 dark:border-zinc-800 dark:bg-[#14161A]"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex items-center">
            {MARQUEE_ITEMS.map((t) => (
              <span
                key={`${dup}-${t}`}
                className="flex items-center gap-10 px-5 text-sm font-medium uppercase tracking-[0.3em] text-zinc-500 dark:text-zinc-400"
              >
                <Diamond size={9} className="fill-bronze text-bronze" />
                {t}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
